import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_loanrequests from './create_newaccounts';



function Admin_loanscheme_calculator(){

  
  
  //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");


 //SETTING DATA VARIABLES
 //scheme_name
 const[scheme_name,setscheme_name]=useState();const updatescheme_name = (event) => { setscheme_name(event.target.value);}; const[scheme_name_er,setscheme_name_er]=useState();
 const[scheme_code,setscheme_code]=useState();const updatescheme_code = (event) => { setscheme_code(event.target.value);}; const[scheme_code_er,setscheme_code_er]=useState();
 const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
 const[loan_amount,setloan_amount]=useState();const updateloan_amount = (event) => { setloan_amount(event.target.value); /*calculate();*/ }; const[loan_amount_er,setloan_amount_er]=useState();
 const[interest_rate,setinterest_rate]=useState();const updateinterest_rate = (event) => { setinterest_rate(event.target.value);}; const[interest_rate_er,setinterest_rate_er]=useState();
 const[pf_per,setpf_per]=useState();const updatepf_per = (event) => { setpf_per(event.target.value); /* calculate(); */ }; const[pf_per_er,setpf_per_er]=useState();
 const[pf_amount,setpf_amount]=useState();const updatepf_amount = (event) => { setpf_amount(event.target.value); /* calculate(); */ }; const[pf_amount_er,setpf_amount_er]=useState();
 const[death_insurance,setdeath_insurance]=useState();const updatedeath_insurance = (event) => { setdeath_insurance(event.target.value); /* calculate(); */ }; const[death_insurance_er,setdeath_insurance_er]=useState();
 const[health_insurance,sethealth_insurance]=useState();const updatehealth_insurance = (event) => { sethealth_insurance(event.target.value); /* calculate(); */ }; const[health_insurance_er,sethealth_insurance_er]=useState();
 const[insurance_gst,setinsurance_gst]=useState();const updateinsurance_gst = (event) => { setinsurance_gst(event.target.value); /* calculate(); */ }; const[insurance_gst_er,setinsurance_gst_er]=useState();
 const[gst_per,setgst_per]=useState();const updategst_per = (event) => { setgst_per(event.target.value); /* calculate(); */ }; const[gst_per_er,setgst_per_er]=useState();
 const[gst_amount,setgst_amount]=useState();const updategst_amount = (event) => { setgst_amount(event.target.value); /* calculate(); */ }; const[gst_amount_er,setgst_amount_er]=useState();
 const[total_additions,settotal_additions]=useState();const updatetotal_additions = (event) => { settotal_additions(event.target.value); /* calculate(); */ }; const[total_additions_er,settotal_additions_er]=useState();
 const[loan_interest,setloan_interest]=useState();const updateloan_interest = (event) => { setloan_interest(event.target.value); /* calculate(); */ }; const[loan_interest_er,setloan_interest_er]=useState();
 const[loan_int_gst,setloan_int_gst]=useState();const updateloan_int_gst = (event) => { setloan_int_gst(event.target.value); /* calculate(); */ }; const[loan_int_gst_er,setloan_int_gst_er]=useState();
 const[duration,setduration]=useState();const updateduration = (event) => { setduration(event.target.value); /* calculate(); */ }; const[duration_er,setduration_er]=useState();
 const[minimum_monthly_income,setminimum_monthly_income]=useState();const updateminimum_monthly_income = (event) => { setminimum_monthly_income(event.target.value);}; const[minimum_monthly_income_er,setminimum_monthly_income_er]=useState();
 const[repayable_amount,setrepayable_amount]=useState();const updaterepayable_amount = (event) => { setrepayable_amount(event.target.value); /* calculate(); */ }; const[repayable_amount_er,setrepayable_amount_er]=useState();
 const[emi,setemi]=useState();const updateemi = (event) => { setemi(event.target.value); /* calculate(); */ }; const[emi_er,setemi_er]=useState();
// const[processing_fee,setprocessing_fee]=useState();const updateprocessing_fee = (event) => { setprocessing_fee(event.target.value); /* calculate(); */ }; const[processing_fee_er,setprocessing_fee_er]=useState();
 const[emi_principle,setemi_principle]=useState();const updateemi_principle = (event) => { setemi_principle(event.target.value); /* calculate(); */ }; const[emi_principle_er,setemi_principle_er]=useState();
 const[emi_interest,setemi_interest]=useState();const updateemi_interest = (event) => { setemi_interest(event.target.value); /* calculate(); */ }; const[emi_interest_er,setemi_interest_er]=useState();
 const[emi_gst,setemi_gst]=useState();const updateemi_gst = (event) => { setemi_gst(event.target.value); /* calculate(); */ }; const[emi_gst_er,setemi_gst_er]=useState();
 const[details,setdetails]=useState();const updatedetails = (event) => { setdetails(event.target.value);}; const[details_er,setdetails_er]=useState();
 const[scheme_document_link,setscheme_document_link]=useState();const updatescheme_document_link = (event) => { setscheme_document_link(event.target.value);}; const[scheme_document_link_er,setscheme_document_link_er]=useState();
 const[installment_gap,setinstallment_gap]=useState(7);const updateinstallment_gap = (event) => { setinstallment_gap(event.target.value); /* calculate(); */ }; const[installment_gap_er,setinstallment_gap_er]=useState();
 const[topup_scheme,settopup_scheme]=useState();const updatetopup_scheme = (event) => { settopup_scheme(event.target.value); /* calculate(); */ }; const[topup_scheme_er,settopup_scheme_er]=useState();

 
 //ERROR VARIABLES 
  const[error_msg,seterror_msg]=useState();


  
  
function calculate(){
  
  //Fetching Values
  let loan_amount = (document.getElementById("loan_amount").value);if(loan_amount==" "){ loan_amount=0;}else{ loan_amount=parseFloat(loan_amount);}
  let interest_rate = (document.getElementById("interest_rate").value);if( interest_rate==" "){ interest_rate=0;}else{ interest_rate=parseFloat(interest_rate);}
 // let pf_per = (document.getElementById("pf_per").value);if( pf_per==" "){ pf_per=0;}else{ pf_per=parseFloat(pf_per);}
 // let pf_amount = (document.getElementById("pf_amount").value);if(pf_amount==" "){ pf_amount=0;}else{ pf_amount=parseFloat(pf_amount);}
 // let gst_per = (document.getElementById("gst_per").value);if( gst_per==" "){ gst_per=0;}else{ gst_per=parseFloat(gst_per);}
  //let gst_amount = (document.getElementById("gst_amount").value);if(gst_amount==" "){ gst_amount=0;}else{ gst_amount=parseFloat(gst_amount);}
//  let insurance_gst = (document.getElementById("insurance_gst").value);if(insurance_gst==" "){ insurance_gst=0;}else{ insurance_gst=parseFloat(insurance_gst);}
//  let death_insurance = (document.getElementById("death_insurance").value);if( death_insurance==" "){ death_insurance=0;}else{ death_insurance=parseFloat(death_insurance);}
//  let health_insurance = (document.getElementById("health_insurance").value);if(health_insurance==" "){ health_insurance=0;}else{ health_insurance=parseFloat(health_insurance);}
//  let total_additions = (document.getElementById("total_additions").value);if( total_additions==" "){ total_additions=0;}else{ total_additions=parseFloat(total_additions);}
  let loan_interest = (document.getElementById("loan_interest").value);if(loan_interest==" "){ loan_interest=0;}else{ loan_interest=parseFloat(loan_interest);}
  let repayable_amount = (document.getElementById("repayable_amount").value);if(repayable_amount==" "){ repayable_amount=0;}else{ repayable_amount=parseFloat(repayable_amount);}
  let emi = (document.getElementById("emi").value);if(emi==" "){ emi=0;}else{ emi=parseFloat(emi);}
//  let processing_fee = (document.getElementById("processing_fee").value);if(processing_fee==" "){ processing_fee=0;}else{ processing_fee=parseFloat(processing_fee);}

  //Interest Calculation
 if(interest_rate>0){ loan_interest = loan_amount*interest_rate/100; }
 //PF Calculation
 //if(pf_per>0){ pf_amount = loan_amount*pf_per/100; }

 //let pre_additions = loan_interest+pf_amount+death_insurance+health_insurance;
 //if(gst_per>0){ gst_amount = loan_amount*gst_per/100; } //calculating gst on insurance instead of loan_amount
 //let insurance_total = death_insurance+health_insurance;
 //let inst_total = insurance_total + loan_interest;
// if(gst_per>0){ gst_amount = insurance_total*gst_per/100; }
//if(gst_per>0){ gst_amount = inst_total*gst_per/100; }
//if(gst_per>0){ insurance_gst = insurance_total*gst_per/100; }

 //gst_amount = insurance_gst+loan_int_gst;
 //repayable_amount = loan_amount+total_additions;
 //repayable_amount = loan_amount+loan_interest;
 //let loan_int_gst = loan_interest*0; //GST on Loan interest calculated from here
 repayable_amount = loan_amount+loan_interest; //+loan_int_gst;
 //let gst_amount = insurance_gst+loan_int_gst;
 //total_additions = pre_additions+gst_amount; //+processing_fee;

 //emi = repayable_amount/duration;
 emi = parseFloat(repayable_amount/duration).toFixed();
 let emi_principle = parseFloat(loan_amount/duration).toFixed();
 let emi_interest = parseFloat(loan_interest/duration).toFixed();
 let emi_gst = parseFloat(loan_int_gst/duration).toFixed();

//setinsurance_gst(insurance_gst);
setloan_interest(loan_interest);
//setloan_int_gst(loan_int_gst);
//setgst_amount(gst_amount);
//setpf_amount(pf_amount);
//settotal_additions(total_additions);
setrepayable_amount(repayable_amount);
setemi(emi);
setemi_principle(emi_principle);
setemi_interest(emi_interest);
//setemi_gst(emi_gst);
 

}


return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Admin Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

   {/*}   <Sidebar /> */}
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">


          <div className="page-header flex-wrap">
          <div className="header-left">
           <button style={{marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-outline-info" onClick={()=>{ window.location.replace("/adminpanel-dashboard-loan-schemes")}}>  Back </button>
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">LOAN SCHEME CALCULATOR</p>
                  </a>
                </div>
          {/*}     <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i>New Loan Request</button>  */}
              </div>
            </div>


                <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Calculate Loan Scheme Installment</h4>
                    <div class="form-sample">
                      <p class="card-description"></p>
                      <code>{error_msg}</code>
                      
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Amount<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="24000.00" id="loan_amount" value={loan_amount} onChange={updateloan_amount} />
                              <code>{loan_amount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Interest Rate<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="20.00" id="interest_rate" value={interest_rate} onChange={updateinterest_rate} />
                              <code>{interest_rate_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                           <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Duration (in weeks)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="26" id="duration" value={duration} onChange={updateduration} />
                              <code>{duration_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                          <button class="btn btn-lg btn-success" style={{fontWeight:"bold"}} onClick={calculate}>Calculate</button>
                          </div>
                        </div>
                        <hr/>
                        <h4 class="card-title">Calculation</h4>
                        <div class="row mt-2">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Interest For Tenure</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="21000.00" id="loan_interest" value={loan_interest} onChange={updateloan_interest} />
                              <code>{loan_interest_er}</code>
                            </div>
                          </div>
                        </div> 
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Total Repayable Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="32500.00" id="repayable_amount" value={repayable_amount} onChange={updaterepayable_amount} />
                              <code>{repayable_amount_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">EMI Principle</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="emi_principle" value={emi_principle} onChange={updateemi_principle} />
                              <code>{emi_principle_er}</code>
                            </div>
                          </div>
                        </div> 
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">EMI Interest</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="200.00" id="emi_interest" value={emi_interest} onChange={updateemi_interest} />
                              <code>{emi_interest_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label"><b>EMI</b></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2200.00" id="emi" value={emi} onChange={updateemi} style={{fontWeight:"bold"}} />
                              <code>{emi_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
             

               {/*}       <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Attach Scheme Document</label>
                            <div class="col-sm-3">
                              <input type="file" class="form-control"  id="logo_link" />
                              
                           
                            </div>
                          <div class="col-sm-5">
                          <p>Allowed File format (.png, .jpg), Max. file Size Allowed 1mb. </p>
                          </div>
                        </div>
                      </div> */}
                                 
                       
    
                     
                   
                    </div>
                  </div>
                </div>

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Admin_loanscheme_calculator;